// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero_wrapper__5pntU","inner":"Hero_inner__XMesd","title":"Hero_title__qEEDw","description":"Hero_description__vqxw6"};